import { useState } from "react";

import { i18n } from "@lingui/core";

import TabHeading from "./TabHeading";
import TabNavigation from "./TabNavigation";

export type Tab<T = Record<string, unknown>> = {
  identifier: string;
  label: string;
  component: React.ElementType;
} & T;
export type TabsProps<T> = {
  tabs: Tab<T>[];
  className?: string;
  active?: number;
  onChange?: (tab: Tab<T>) => void;
};

const Tabs = <T,>({ tabs, className, active = 0, onChange }: TabsProps<T>) => {
  const [tabIndex, setTabIndex] = useState<number>(active);

  const handleTabNavigation = (index: number, tab: Tab<T>) => {
    setTabIndex(index);
    onChange && onChange(tab);
  };

  const Component = tabs[tabIndex].component;

  return (
    <>
      <TabNavigation className={className}>
        {tabs.map((tab, index) => (
          <TabHeading
            data-testid={`tab-heading-${tab.identifier}`}
            active={index === tabIndex}
            key={index}
            onClick={() => handleTabNavigation(index, tab)}
          >
            {i18n._(tab.label)}
          </TabHeading>
        ))}
      </TabNavigation>
      {Component && <Component />}
    </>
  );
};
export default Tabs;
